import 'reset-css';
import '../../styles/desktop/_top.css'

import '../shared/index';
import '../shared/fixed-header';

import $ from 'jquery';

((($) => {

})(jQuery));
